import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from '@nuxtjs/composition-api';
import { onClickOutside } from '@vueuse/core';
import { useBreakpoint } from '~/composables';

interface Props {
  value?: boolean;
  width?: string;
  height?: string;
  closeButton?: string | boolean;
  rounded?: 'lg' | '2xl';
  background?: 'white' | 'gray' | 'transparent';
  alignCenter?: boolean;
  renderContentOnMount?: boolean;
}
interface Emits {
  (e: 'input', data: Props['value']): void;
}
type BtnStyle = keyof typeof styles.button;


export default /*#__PURE__*/_defineComponent({
  __name: 'UiModal',
  props: {
    value: { type: Boolean, default: false },
    width: { default: '' },
    height: { default: 'auto' },
    closeButton: { type: [String, Boolean], default: 'default' },
    rounded: { default: 'lg' },
    background: { default: 'white' },
    alignCenter: { type: Boolean, default: false },
    renderContentOnMount: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'input', data: Props['value']): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, width: string, height: string, closeButton: string | boolean, rounded: 'lg' | '2xl', background: 'white' | 'gray' | 'transparent', alignCenter: boolean, renderContentOnMount: boolean };





const styles = {
  background: {
    white: 'bg-white',
    gray: 'bg-gray-lighten3',
    transparent: '',
  },
  roundings: {
    lg: 'md:rounded-lg',
    '2xl': 'md:rounded-2xl',
  },
  button: {
    outside: 'right-0 -top-[3.25rem] text-white',
    default: 'top-3 right-3 md:top-6 md:right-6',
  },
};

const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('sm');
const modal = ref();
const isOpen = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

const closeButtonStyles = computed(() =>
  props.closeButton
    ? styles.button[props.closeButton as BtnStyle] ?? styles.button.default
    : null,
);

const close = () => (isOpen.value = false);
const open = () => (isOpen.value = true);

expose({ open });

onClickOutside(modal as any, () => close());

return { __sfc: true,props, emit, styles, isDesktop, modal, isOpen, closeButtonStyles, close, open }
}

})